import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.split";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import SplitFlap from './SplitFlap';

function getMaxChars(arr) {
  var lengths = arr.map(function (str) {
    return str.length;
  });
  return Math.max.apply(null, lengths);
}

function getCharacters(text, index) {
  var currentText = index ? text : '';
  var maxChars = text.length;

  if (Array.isArray(text)) {
    maxChars = getMaxChars(text);
    currentText = text[index];
  }

  while (currentText.length < maxChars) {
    currentText += ' ';
  }

  return currentText.toString().toUpperCase().split('');
}

function defaultState(_ref) {
  var text = _ref.text;
  return {
    wordIndex: 0,
    characterIndex: 0,
    currentChars: getCharacters(text, 0),
    nextChars: getCharacters(text, 1)
  };
}

var FlapDisplay =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FlapDisplay, _React$Component);

  function FlapDisplay() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FlapDisplay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FlapDisplay)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", defaultState(_this.props));

    _defineProperty(_assertThisInitialized(_this), "flipNextChar", function () {
      var _this$props = _this.props,
          sequenceDelay = _this$props.sequenceDelay,
          text = _this$props.text;
      var _this$state = _this.state,
          characterIndex = _this$state.characterIndex,
          wordIndex = _this$state.wordIndex,
          nextChars = _this$state.nextChars;

      if (characterIndex < nextChars.length) {
        // Move on to the next character
        _this.setState({
          characterIndex: characterIndex + 1
        }, function () {
          setTimeout(_this.flipNextChar, sequenceDelay);
        });
      } else if (Array.isArray(text) && wordIndex < text.length - 2) {
        // Move on to the next word
        _this.setState({
          characterIndex: 0,
          wordIndex: wordIndex + 1,
          currentChars: nextChars,
          nextChars: getCharacters(text, wordIndex + 2)
        }, function () {
          setTimeout(_this.flipNextChar, sequenceDelay);
        });
      }
    });

    return _this;
  }

  _createClass(FlapDisplay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var startDelay = this.props.startDelay;
      setTimeout(this.flipNextChar, startDelay);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          startDelay = _this$props2.startDelay,
          sequenceDelay = _this$props2.sequenceDelay,
          rest = _objectWithoutProperties(_this$props2, ["className", "startDelay", "sequenceDelay"]);

      var _this$state2 = this.state,
          characterIndex = _this$state2.characterIndex,
          currentChars = _this$state2.currentChars,
          nextChars = _this$state2.nextChars;
      var classNames = [];

      if (className) {
        classNames.push(className);
      }

      return React.createElement("div", _extends({
        className: classNames.length ? classNames.join(' ') : undefined
      }, rest), currentChars.map(function (char, i) {
        return React.createElement(SplitFlap, {
          currentChar: char,
          flipping: i < characterIndex,
          key: "".concat(char, "_").concat(i.toString()),
          nextChar: nextChars[i]
        });
      }));
    }
  }]);

  return FlapDisplay;
}(React.Component);

_defineProperty(FlapDisplay, "propTypes", {
  /** String(s) used in the display */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Milliseconds before starting animation */
  startDelay: PropTypes.number,

  /** Milliseconds between each character flip */
  sequenceDelay: PropTypes.number
});

_defineProperty(FlapDisplay, "defaultProps", {
  text: 'GasBuddy',
  className: undefined,
  startDelay: 500,
  sequenceDelay: 200
});

export default FlapDisplay;